var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$store.state.me.demo)?_c('div',{staticClass:"demo-alert-container"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"demo-alert"},[_c('img',{staticStyle:{"height":"20px"},attrs:{"src":require("assets/icons/material-warning.svg"),"alt":"alert icon"}}),_vm._v("こちらは共用のデモ画面です。個人情報や園の情報を入力しないでください。")])
}]

export { render, staticRenderFns }